import firebase_app from '../firebaseConfig'
import { getFirestore, where, orderBy, limit, collection, query, onSnapshot } from 'firebase/firestore'

const db = getFirestore(firebase_app)

// Constants
import { COLLECTION_NAME, SORT_BY_KEY, APPROVE_STATUS, REVIEW_SORT_BY_KEY } from '../../../constants/Constants'

// User
// Customize query for product collection
export const subscribeFeedbackData = async (
  type,
  sortBy,
  sortValue,
  sortType,
  previousPage,
  currentPage,
  numberLimit,
  currentProducts,
  callback
) => {
  let value = '0'
  let operation = '>'
  let sorted = sortType
  let fieldSearch = 'createdAt'
  let fieldSort = 'createdAt'
  let fieldValue = 'createdAt'

  //REVIEW_SORT_BY_KEY
  if (currentPage > 1) {
    if (previousPage < currentPage) {
      if (currentProducts.length > 0) {
        const productItem = currentProducts[currentProducts.length - 1]
        value = productItem[fieldValue]

        //
        if (sortType === SORT_BY_KEY.DESC) {
          operation = '<'
          sorted = SORT_BY_KEY.DESC
        } else {
          operation = '>'
          sorted = SORT_BY_KEY.ASC
        }
      }
    } else if (currentProducts.length > 0) {
      const productItem = currentProducts[0]
      value = productItem[fieldValue]

      //
      if (sortType === SORT_BY_KEY.DESC) {
        operation = '>'
        sorted = SORT_BY_KEY.ASC
      } else {
        operation = '<'
        sorted = SORT_BY_KEY.DESC
      }
    }
  } else if (sortType === SORT_BY_KEY.DESC) {
    sorted = SORT_BY_KEY.DESC
  } else {
    sorted = SORT_BY_KEY.ASC
  }

  //
  const collectionName = COLLECTION_NAME.FEEDBACK

  //
  const numberItem = numberLimit

  const userColRef = collection(db, collectionName)

  // Create a query against the collection.
  let q = query(
    userColRef,
    where('type', '==', type),
    where(fieldSearch, operation, value),
    orderBy(fieldSort, sorted),
    limit(numberItem)
  )

  //
  if (sortBy === REVIEW_SORT_BY_KEY.ALL) {
    q = query(q, where('isDel', '==', false), where('status', '==', APPROVE_STATUS.APPROVED))
  } else {
    if (sortBy === REVIEW_SORT_BY_KEY.USER) {
      q = query(q, where('createdUser._id', 'in', sortValue))
    } else if (sortBy === REVIEW_SORT_BY_KEY.STATUS) {
      q = query(q, where('status', 'in', sortValue))
    }
  }

  const unsubscribe = onSnapshot(
    q,
    querySnapshot => {
      let allData = []
      querySnapshot.forEach(doc => {
        allData.push(doc.data())
      })
      //
      if (sorted === SORT_BY_KEY.DESC) {
        allData.sort((a, b) => b[fieldValue] - a[fieldValue])
      } else {
        allData.sort((a, b) => a[fieldValue] - b[fieldValue])
      }
      // console.log('allData:', allData)
      callback(allData, null)
    },
    error => {
      console.log('error:', error)
      // ...
      callback(null, error)
    }
  )

  return unsubscribe
}
